import Alert from '@mui/material/Alert'
import * as React from 'react'

export function NoResults() {
  return <Alert severity="info">No activities found</Alert>
}
